module.exports = "https://static.wmbcdn.com/uniweb/images/d07cad437ce7a880a442462256e754c3.svg";